import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {
	InputSelect,
	Image
} from '@emersya/mpa-components';
import * as BasketNS from '@emersya/mpa-basket';

export interface IProductEditorComponentConfiguration extends InputSelect.Configuration {
	// products are relative to the app so retrieve them from app config
};

export class ProductEditorComponent extends InputSelect.Component<
	ProductEditorComponent,
	IProductEditorComponentConfiguration
> {
	static override getInputEventSubType() {
		const parentClass = <typeof CM.Component><any>STD.object.getParentClassFromClass(this);
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Select', {});
		}
		return parentClass.type;
	};

	async addProduct(product: typeof app.component_configuration.PMS.products[number]) {
		if (!app.basket) {
			throw new Error;
		}
		const basketProduct = await app.basket.basket.createProductAndInitialize({
			id: product.SKU,
			title: product.translations['@name'][app.currentLanguage]!,
			reference: product.SKU,
			sku: product.SKU,
			viewerCode: product.d3.viewer.routingCode,
			gtin: null,
			quantity: 1,
			metaData: {
				get PMS() {
					return <any>product;
				}
			},
			parts: [],
			pricing: product.pricing ? BasketNS.Pricing.deserialize(<BasketNS.Pricing.FinalPricing.ISerialized & BasketNS.Pricing.BoundPricing.ISerialized>product.pricing) : null,
			configurationCode: product.d3.configurationCode
		});
		const productTile = <CM.DOMComponent<any, any, any>>await this.component_instantiateOuterChild<ProductTileNS.Configuration>(
			{
				type: 'product-tile',
				id: product.SKU,
				tree: this.component_tree,
				slot: null,
				isSlot: false,
				configuration: {
					SKU: product.SKU,
					viewerCode: product.d3.viewer.routingCode,
					iconURL: product.iconURL,
					basketProduct,
					'@innerConfigurations': {
						'image': <Image.Configuration>{
							'@translations': {
								'name': product.translations['@name']
							},
							'URL': product.iconURL
						},
						'title': {
							'@translations': {
								'text': product.translations['@name']
							}
						}
					}
				}
			}
		);
		return productTile;
	};

	async deleteProduct(productSKU: string) {
		if (!app.basket) {
			throw new Error;
		}
		await app.basket.basket.removeProduct(productSKU);
		const tile = this.component_outerChilds.find(x => x.id === productSKU);
		if (!tile) {
			this.component_throwLibraryError('Product not found!', {
				productSKU
			});
		}
		await tile.component_delete();
	};

	override async component_initialize() {
		for (const product of app.component_configuration.PMS.products) {
			await this.addProduct(product);
		}
		await super.component_initialize();
	};

	protected override async onValueUpdated(ev: STD.events.Event<any, CM.Component<any, any>>) {
		await super.onValueUpdated(ev);
		if (app.basket && this.value) {
			if (!app.basket.basket.currentProduct || app.basket.basket.currentProduct.id != this.value.id) {
				await app.basket.basket.useProduct(this.value.id);
			}
		}
	};
};
export namespace NS {
	export const Component = ProductEditorComponent;
	export type Component = ProductEditorComponent;
	export type Configuration = IProductEditorComponentConfiguration;
}
;
import manifestXMLSource from './ProductEditor.xml';
import './ProductEditor.scss';
import {NS as ProductTileNS} from '../ProductTile/ProductTile';

CM.Manager.declare({
	id: 'product-editor',
	type: ProductEditorComponent,
	manifest: manifestXMLSource
});
